import SectionTitle from "../atoms/SectionTitle";
import Section, { StyledSectionImage } from "../molecules/Section";

import ExperienceImage from "../../assets/icons/experience.svg";
import { styled } from "styled-components";

const Experience = () => {
  return (
    <Section id="experience">
      <SectionTitle title="experience" />
      <StyledSectionImage src={ExperienceImage} alt="" />

      <StyledExperiencesWrapper>
        <StyledExperienceWithProjects>
          <StyledSingleExperience>
            <StyledJob>Frontend Developer</StyledJob>
            <StyledDate>07.25 - NOW</StyledDate>
            <StyledCompany>inDigital</StyledCompany>
          </StyledSingleExperience>

          <StyledProjects>
            <a href="https://domesta.com.pl/" target="_blank" rel="noreferrer">Domesta</a>
            <a href="https://www.afi.global/en" target="_blank" rel="noreferrer">AFI Global</a>
            <a href="https://archicomcollection.pl/" target="_blank" rel="noreferrer">Archicomcollection</a>
            <a href="https://budlex.pl/" target="_blank" rel="noreferrer">Budlex</a>
            <a href="https://www.homeden.pl/" target="_blank" rel="noreferrer">Homeden</a>
            <a href="https://www.goes.pl/" target="_blank" rel="noreferrer">GOES</a>
            <a href="https://systemelfa.pl/" target="_blank" rel="noreferrer">System Elfa</a>
            <a href="https://bulwarypraskie.pl/" target="_blank" rel="noreferrer">Bulwary Praskie</a>
            <a href="https://magazyny.pl/" target="_blank" rel="noreferrer">Magazyny.pl</a>
          </StyledProjects>
        </StyledExperienceWithProjects>

        <StyledExperienceWithProjects>
          <StyledSingleExperience>
            <StyledJob>Frontend Developer</StyledJob>
            <StyledDate>02.24 - 03.25</StyledDate>
            <StyledCompany>beeCommerce.pl</StyledCompany>
          </StyledSingleExperience>

          <StyledProjects>
            <a href="https://beecommerce.pl/realizacje/wygodne-uslugi-czyszczenie-butow-w-sklepach-zabka-woshwosh" target="_blank" rel="noreferrer">Żabka X Woshwosh</a>
            <a href="https://beecommerce.pl/realizacje/woshwosh-wms-i-automatyzacje-procesow" target="_blank" rel="noreferrer">Woshwosh</a>
            <a href="https://beecommerce.pl/realizacje/scrips" target="_blank" rel="noreferrer">Scrips</a>
            <a href="https://beecommerce.pl/realizacje/adytozaur" target="_blank" rel="noreferrer">Audytozaur</a>
            <a href="https://beecommerce.pl/realizacje/e-garderobe-com-wypozyczalnia" target="_blank" rel="noreferrer">E-Garderobe</a>
            <a href="https://beecommerce.pl/realizacje/agrosimex-2-0" target="_blank" rel="noreferrer">Agrosimex</a>
          </StyledProjects>
        </StyledExperienceWithProjects>

        <StyledExperienceWithProjects>
          <StyledSingleExperience>
            <StyledJob>Frontend Developer</StyledJob>
            <StyledDate>09.22 - 01.26</StyledDate>
            <StyledCompany>PayFor/Tripsomnia</StyledCompany>
          </StyledSingleExperience>

          <StyledProjects>
            <a href="https://www.tripsomania.com" target="_blank" rel="noreferrer">Tripsomania</a>
            <a href="https://tripsomnia.com" target="_blank" rel="noreferrer">Tripsomnia</a>
            <a href="https://www.tripso.ai" target="_blank" rel="noreferrer">Tripso.ai</a>
            <a href="https://couponmanager.pl/" target="_blank" rel="noreferrer">Coupon manager</a>
            <a href="https://payfor.travel/" target="_blank" rel="noreferrer">PayFor.travel</a>
          </StyledProjects>
        </StyledExperienceWithProjects>
      </StyledExperiencesWrapper>
    </Section>
  );
};

const StyledExperiencesWrapper = styled.div`
  margin-top: 78px;
  display: flex;
  flex-direction: column;
  gap: 150px;
`;

const StyledExperienceWithProjects = styled.article``;

const StyledSingleExperience = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const StyledProjects = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-flow: wrap row;
  margin-top: 10px;

  a {
    color: ${({ theme }) => theme.colors.primaryText03};
    font-weight: 600;
    font-size: 18px;
    text-transform: uppercase;
    text-align: center;

    &:hover {
      color: ${({ theme }) => theme.colors.highlightedText};
    }
  }

  @media (min-width: 620px) {
    margin-top: 0;
  }
`;

const StyledDate = styled.span`
  font-weight: 900;
  color: ${({ theme }) => theme.colors.primaryText03};
  font-size: 32px;
  text-align: center;
  @media (min-width: 290px) {
    font-size: 38px;
  }
  @media (min-width: 365px) {
    font-size: 50px;
  }
  @media (min-width: 500px) {
    font-size: 56px;
  }
  @media (min-width: 620px) {
    font-size: 68px;
  }
  @media (min-width: 800px) {
    font-size: 82px;
  }
  @media (min-width: 1000px) {
    font-size: 108px;
  }
`;

const StyledJob = styled.strong`
  position: absolute;
  top: -3px;
  color: ${({ theme }) => theme.colors.highlightedText};
  @media (min-width: 365px) {
    font-size: 18px;
    top: -1px;
  }
  @media (min-width: 500px) {
    font-size: 20px;
    top: -1px;
  }
  @media (min-width: 620px) {
    font-size: 22px;
    top: 2px;
  }
  @media (min-width: 800px) {
    font-size: 24px;
    top: 6px;
  }
  @media (min-width: 1000px) {
    font-size: 34px;
    top: 9px;
  }
`;

const StyledCompany = styled.strong`
  position: absolute;
  bottom: -2px;
  @media (min-width: 365px) {
    bottom: 4px;
  }
  @media (min-width: 500px) {
    font-size: 18px;
  }
  @media (min-width: 620px) {
    font-size: 20px;
    bottom: 6px;
  }
  @media (min-width: 800px) {
    font-size: 22px;
    bottom: 12px;
  }
  @media (min-width: 1000px) {
    font-size: 28px;
    bottom: 14px;
  }
`;

export default Experience;
